type StorageLike = Pick<Storage, "getItem" | "setItem" | "removeItem">;

function safeStorage(getter: () => StorageLike): StorageLike | null {
  try {
    return getter();
  } catch {
    return null;
  }
}

export const tffLocal: StorageLike | null = safeStorage(() => window.localStorage);
export const tffSession: StorageLike | null = safeStorage(() => window.sessionStorage);

// Speichert in sessionStorage und localStorage
export function setAny(key: string, value: string) {
  if (tffSession) {
    try {
      tffSession.setItem(key, value);
    } catch {}
  }
  if (tffLocal) {
    try {
      tffLocal.setItem(key, value);
    } catch {}
  }
}

// Liest erst sessionStorage dann localStorage
export function getAny(key: string): string | null {
  let v: string | null = null;

  if (tffSession) {
    try {
      v = tffSession.getItem(key);
    } catch {
      v = null;
    }
  }

  if (v) return v;

  if (tffLocal) {
    try {
      return tffLocal.getItem(key);
    } catch {
      return null;
    }
  }

  return null;
}

// Löscht aus sessionStorage und localStorage
export function removeAny(key: string) {
  if (tffSession) {
    try {
      tffSession.removeItem(key);
    } catch {}
  }
  if (tffLocal) {
    try {
      tffLocal.removeItem(key);
    } catch {}
  }
}

// Kompatibilität für AdminPage
export function getSession(key: string): string | null {
  return getAny(key);
}

export function setSession(key: string, value: string) {
  setAny(key, value);
}

export function clearSession(key: string) {
  removeAny(key);
}
